export const TWO_FA_METHODS = {
  AUTHY: 'AUTHY',
};
